import React from "react";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import ReactStars from "react-rating-stars-component";
import { data } from "../../mock/recommend";

export default function RecommendCard(props) {
  const ref = React.useRef();
  const [centerSlideDataIndex, setCenterSlideDataIndex] = React.useState(0);
  const onCenterSlideDataIndexChange = (newIndex) => {
    setCenterSlideDataIndex(newIndex);
  };
  return (
    <div className="real w-full ">
      <ResponsiveContainer
        carouselRef={ref}
        render={(parentWidth, carouselRef) => {
          let currentVisibleSlide = 3;
          if (parentWidth <= 768) currentVisibleSlide = 3;
          if (parentWidth <= 480) currentVisibleSlide = 1;
          return (
            <StackedCarousel
              ref={carouselRef}
              slideComponent={Card}
              slideWidth={parentWidth < 480 ? parentWidth - 60 : 400}
              carouselWidth={parentWidth}
              data={data}
              currentVisibleSlide={currentVisibleSlide}
              maxVisibleSlide={5}
              useGrabCursor
              onActiveSlideChange={onCenterSlideDataIndexChange}
            />
          );
        }}
      />

      <Pagination centerSlideDataIndex={centerSlideDataIndex} />
    </div>
  );
}
function Pagination(props) {
  return (
    <div className="mt-5 flex justify-center gap-3 md:mt-8">
      {data.map((_, index) => {
        const isCenterSlide = props.centerSlideDataIndex === index;
        return (
          <div
            key={"pageCar" + index}
            className={` h-2.5 w-2.5 rounded-full ${
              isCenterSlide
                ? "bg-cyan-400 shadow-[0_0_8px_1px_#0a80ee85]"
                : "bg-gray-300"
            }`}
          />
        );
      })}
    </div>
  );
}
export const Card = React.memo(function (props) {
  const { data, dataIndex } = props;
  const item = data[dataIndex];
  return (
    <div className="my-slide-component w-full select-none text-gold-black border-gold-main dark:bg-dark-light bg-gray-100">
      <div
        className="border-1 flex h-[450px] w-full flex-col rounded-md border border-gray-300 bg-white p-4 text-left shadow-md dark:border-[#464646] dark:bg-[#222121] sm:h-[420px] lg:h-[400px]"
        draggable={false}
      >
        <div>{item.star}</div>
        <div className="mb-3 mt-4 flex items-end gap-5">
          <div className="border-1 h-16 w-16 rounded-full border border-yellow-300">
            <img src={item.avatar} className="h-full w-full rounded-full"></img>
          </div>
          <div className="text-blue-300">
            <div className="text-primary-500">{item.name}</div>
            <div>{item.position}</div>
          </div>
        </div>
        <div className="mt-3 mb-auto text-[15px] text-[#9c9fa1]">
          {item.description}
        </div>
        <ReactStars
          edit={false}
          value={item.stars}
          count={5}
          size={24}
          activeColor="#ffd700"
          classNames={"ml-auto"}
        />
      </div>
    </div>
  );
});
